import {USER_LOGGED_OUT} from "../../user/constants/actionTypes";
import {
  RELATIVES_ADD,
  RELATIVES_FETCH,
  SENIORS_CHECKBOX,
  SENIORS_FETCH,
  RC_CLOSE
} from "../constants/actionTypes";

export const memberReducer = (state = [], action) => {
  switch (action.type) {
    case RC_CLOSE:
    case USER_LOGGED_OUT:
      return [];
    case SENIORS_FETCH:
      return action.payload.map((senior) => {
        return {
          ...senior,
          relatives: []
        };
      });
    case RELATIVES_FETCH:
      return state.map((senior) => {
        return {
          ...senior,
          relatives: action.payload.filter((relative) => {
            return relative.prof_id === senior.prof_id;
          }) || []
        };
      });
    case RELATIVES_ADD:
      return state.map((senior) => {
        return {
          ...senior,
          relatives: senior.prof_id === action.payload.prof_id
            ? [
              ...senior.relatives,
              {...action.payload}
            ]
            : [...senior.relatives]
        };
      });
    case SENIORS_CHECKBOX:
      return state.map((senior) => {
        return {
          ...senior,
          checkbox: action.payload.profId === senior.prof_id &&
          action.payload.deviceId === senior.device_id
            ? action.payload.state
            : senior.checkbox
        };
      });
    default:
      return state;
  }
};
